import { render, staticRenderFns } from "./SingleColorSinglePlanetSlide.vue?vue&type=template&id=1bb5253f"
import script from "./SingleColorSinglePlanetSlide.vue?vue&type=script&lang=js"
export * from "./SingleColorSinglePlanetSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports